import { Injectable } from '@angular/core';
import { RouterOutlets } from '@rootTypes/entities/router';
import { getRoutingRequest } from '@rootTypes/utils/router/get-routing-request';
import { NavigationRequest } from '../../types/navigation-request';
import { PortalRoute, QueryParamsHandlingStrategy } from '../../types/portal-route';
import { PortalRouterService } from '../../types/portal-router-service';
import { RouterStateUrl } from '../../types/router-state-url';
import { VendorEmployeeDetailsRouteData } from './vendor-employee-details';

export interface EditEmployeeProfileRouteData {
  employeeId: string;
}

export const vendorEmployeeEditProfileRoute: PortalRoute<EditEmployeeProfileRouteData> = {
  path: '',
  isOnRoute: (state: RouterStateUrl): boolean => {
    throw new Error('Not implemented');
  },
  parse: (state: RouterStateUrl): EditEmployeeProfileRouteData => {
    let data: EditEmployeeProfileRouteData = {
      employeeId: state.drawer.params.employeeId,
    };
    if (state.queryParams) {
      data = {
        ...data,
        ...state.queryParams,
      };
    }
    return data;
  },
  request: (
    data: EditEmployeeProfileRouteData,
    queryParamStrategy?: QueryParamsHandlingStrategy,
    replaceUrl?,
  ): NavigationRequest => {
    const path = ['_', 'drawer', 'vendor-employees', ':employeeId', 'edit-profile'];
    const routeData = { ...data };
    return getRoutingRequest(path, routeData, queryParamStrategy, replaceUrl);
  },
};

@Injectable({ providedIn: 'root' })
export class VendorEmployeeEditProfileRouterService extends PortalRouterService<VendorEmployeeDetailsRouteData> {
  outlet = RouterOutlets.DRAWER;
  route: PortalRoute<VendorEmployeeDetailsRouteData> = vendorEmployeeEditProfileRoute;
}
